import React from 'react'

import Link, { Appearance } from '@cinch/oxd-components/link/src'
import Panel from '@cinch/oxd-components/panel/src'

export interface JargonSummaryProps {
  id: string
  title: string
  subtitle: string
}

import * as styles from './jargon-summary.module.css'

const JargonSummary: React.FC<JargonSummaryProps> = ({ title, subtitle, id }) => (
  <Panel title={title} subtitle={subtitle}>
    <Link
      oxford={true}
      to={`/jargon/${id}`}
      appearance={Appearance.outlineButton}
      className={styles.link}
      data-testid="jargonLink"
    >
      <span className={styles.inner}>Read more</span>
    </Link>
  </Panel>
)

export default JargonSummary
